export const Wordmark = ({ className = "", dark = false }) => (
  <span className={`font-extrabold tracking-tighter ${dark ? "text-white" : "text-[#0A0807]"} ${className}`} data-testid="brand-wordmark">
    my<span className="text-[#E08A1E] font-black">°</span>bev
  </span>
);
